import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FieldviewService } from '../../services/fieldview.service';
import { UserService } from '../../services/user.service';

import { ModalService } from '../../services/modal.service';
import { I18nTranslator } from '../../i18n/translate';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  standalone: true,
  selector: 'fieldviewLink-cmp',
  templateUrl: 'fieldviewLink.html',
  styleUrls: ['fieldviewLink.scss'],
  providers: [FieldviewService, UserService],
  imports: [TranslatePipe],
})
export class FieldviewLink implements OnInit {
  constructor(
    private router: Router,
    private secureLink: FieldviewService,
    private i18nTranslator: I18nTranslator,
    private modal: ModalService,
  ) {}

  ngOnInit() {
    const url = window.location.href.split('?');
    if (url[1] == undefined || !url[1].includes('code')) {
      this.router.navigate(['/home']);
      return;
    }
    const code = url[1].split('=');
    this.secureLink.createFieldviewUser(code[1]).subscribe(
      (data: any) => {
        this.modal.alert(this.i18nTranslator.translate('fieldview.connect.success')).then(() => {
          const goodUrl = window.location.href.split('?');
          window.history.replaceState({}, null, goodUrl[0]);
          this.router.navigate(['/home'], { queryParams: {} });
        });
      },
      (err) => {
        this.modal.alert(this.i18nTranslator.translate('fieldview.connect.error')).then(() => {
          const goodUrl = window.location.href.split('?');
          window.history.replaceState({}, null, goodUrl[0]);
          this.router.navigate(['/home'], { queryParams: {} });
        });
      },
    );
  }
}
